export default "__VITE_ASSET__BxJiUPR5__"